import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_bootstrapvue_b096466c from 'nuxt_plugin_bootstrapvue_b096466c' // Source: ./bootstrap-vue.js (mode: 'all')
import nuxt_plugin_pluginutils_68bfae00 from 'nuxt_plugin_pluginutils_68bfae00' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_24e6896a from 'nuxt_plugin_pluginrouting_24e6896a' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_a14027f8 from 'nuxt_plugin_pluginmain_a14027f8' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_5485c99b from 'nuxt_plugin_axios_5485c99b' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_highchartsvue_0c91c026 from 'nuxt_plugin_highchartsvue_0c91c026' // Source: ../plugins/highcharts-vue (mode: 'all')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_vSelect_475ab648 from 'nuxt_plugin_vSelect_475ab648' // Source: ../plugins/vSelect (mode: 'all')
import nuxt_plugin_envconfig_7e3fb018 from 'nuxt_plugin_envconfig_7e3fb018' // Source: ../plugins/env-config (mode: 'all')
import nuxt_plugin_getErrorMessage_60e7e878 from 'nuxt_plugin_getErrorMessage_60e7e878' // Source: ../plugins/getErrorMessage.js (mode: 'all')
import nuxt_plugin_dayjs_35268fa2 from 'nuxt_plugin_dayjs_35268fa2' // Source: ../plugins/dayjs (mode: 'all')
import nuxt_plugin_ipc_5e4640e6 from 'nuxt_plugin_ipc_5e4640e6' // Source: ../plugins/ipc (mode: 'all')
import nuxt_plugin_isHavePermissions_3ceb4a88 from 'nuxt_plugin_isHavePermissions_3ceb4a88' // Source: ../plugins/isHavePermissions (mode: 'all')
import nuxt_plugin_hboCheckPermission_0019e910 from 'nuxt_plugin_hboCheckPermission_0019e910' // Source: ../plugins/hboCheckPermission (mode: 'all')
import nuxt_plugin_examNewFormula_5a3c85fc from 'nuxt_plugin_examNewFormula_5a3c85fc' // Source: ../plugins/examNewFormula.js (mode: 'all')
import nuxt_plugin_impersonation_27b19534 from 'nuxt_plugin_impersonation_27b19534' // Source: ../plugins/impersonation (mode: 'all')
import nuxt_plugin_vuehtml2pdf_796dc3f4 from 'nuxt_plugin_vuehtml2pdf_796dc3f4' // Source: ../plugins/vue-html2pdf (mode: 'client')
import nuxt_plugin_vuepictureinput_c0e86986 from 'nuxt_plugin_vuepictureinput_c0e86986' // Source: ../plugins/vue-picture-input (mode: 'client')
import nuxt_plugin_bugsnag_27838704 from 'nuxt_plugin_bugsnag_27838704' // Source: ../plugins/bugsnag (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"titleTemplate":"%s | Bodygram","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Bodygram Cloud App"},{"name":"robots","content":"noindex"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      errPageReady: false,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        nuxt.errPageReady = false
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_bootstrapvue_b096466c === 'function') {
    await nuxt_plugin_bootstrapvue_b096466c(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_68bfae00 === 'function') {
    await nuxt_plugin_pluginutils_68bfae00(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_24e6896a === 'function') {
    await nuxt_plugin_pluginrouting_24e6896a(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_a14027f8 === 'function') {
    await nuxt_plugin_pluginmain_a14027f8(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5485c99b === 'function') {
    await nuxt_plugin_axios_5485c99b(app.context, inject)
  }

  if (typeof nuxt_plugin_highchartsvue_0c91c026 === 'function') {
    await nuxt_plugin_highchartsvue_0c91c026(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (typeof nuxt_plugin_vSelect_475ab648 === 'function') {
    await nuxt_plugin_vSelect_475ab648(app.context, inject)
  }

  if (typeof nuxt_plugin_envconfig_7e3fb018 === 'function') {
    await nuxt_plugin_envconfig_7e3fb018(app.context, inject)
  }

  if (typeof nuxt_plugin_getErrorMessage_60e7e878 === 'function') {
    await nuxt_plugin_getErrorMessage_60e7e878(app.context, inject)
  }

  if (typeof nuxt_plugin_dayjs_35268fa2 === 'function') {
    await nuxt_plugin_dayjs_35268fa2(app.context, inject)
  }

  if (typeof nuxt_plugin_ipc_5e4640e6 === 'function') {
    await nuxt_plugin_ipc_5e4640e6(app.context, inject)
  }

  if (typeof nuxt_plugin_isHavePermissions_3ceb4a88 === 'function') {
    await nuxt_plugin_isHavePermissions_3ceb4a88(app.context, inject)
  }

  if (typeof nuxt_plugin_hboCheckPermission_0019e910 === 'function') {
    await nuxt_plugin_hboCheckPermission_0019e910(app.context, inject)
  }

  if (typeof nuxt_plugin_examNewFormula_5a3c85fc === 'function') {
    await nuxt_plugin_examNewFormula_5a3c85fc(app.context, inject)
  }

  if (typeof nuxt_plugin_impersonation_27b19534 === 'function') {
    await nuxt_plugin_impersonation_27b19534(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuehtml2pdf_796dc3f4 === 'function') {
    await nuxt_plugin_vuehtml2pdf_796dc3f4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuepictureinput_c0e86986 === 'function') {
    await nuxt_plugin_vuepictureinput_c0e86986(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bugsnag_27838704 === 'function') {
    await nuxt_plugin_bugsnag_27838704(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
